import Cookies from 'js-cookie'

document.addEventListener('DOMContentLoaded', function () {
    let overlay = document.querySelector('.global-overlay')

    let newsletterPopup = document.querySelector('.newsletter-popup')
    let newsletterOpenButton = document.querySelector('.js-newsletter-popup-open')
    let newsletterCloseButton = document.querySelector('.js-newsletter-popup-close')

    // When the user successfully subscribes, the newsletter popup will be hidden for the time defined in `/resources/js/elements/forms/newsletter-form.js`
    let newsletterCookie = 'deltabg_newsletter_popup'
    let newsletterShowOnScroll = 0.5 // scrolled 50% of the page
    let newsletterCookieDuration = (1 / 24) * 2 // 2 hours

    function toggleNewsletterPopup(state) {
        if (state === 'show') {
            overlay.classList.add('show')
            overlay.style.zIndex = '5'
            newsletterPopup.classList.add('active')
        } else {
            overlay.classList.remove('show')
            overlay.style.zIndex = ''
            newsletterPopup.classList.remove('active')
        }
    }

    // Show only if a certain percentage of the page is scrolled, and the popup has not been closed previously
    window.addEventListener('scroll', function () {
        if (newsletterPopup && Cookies.get(newsletterCookie) != 1) {
            let documentHeight = document.documentElement.scrollHeight * newsletterShowOnScroll

            if (window.scrollY > documentHeight) {
                toggleNewsletterPopup('show')
            }
        }
    })

    // Open popup on click
    if (newsletterOpenButton) {
        newsletterOpenButton.addEventListener('click', function () {
            toggleNewsletterPopup('show')
        })
    }

    // Close popup on click
    if (newsletterCloseButton) {
        newsletterCloseButton.addEventListener('click', function () {
            if (Cookies.get(newsletterCookie) != 1) {
                Cookies.set(newsletterCookie, 1, {
                    expires: newsletterCookieDuration,
                    path: '/'
                })
            }

            toggleNewsletterPopup('close')
        })
    }

    // Close popup on click outside
    overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
            if (Cookies.get(newsletterCookie) != 1) {
                Cookies.set(newsletterCookie, 1, {
                    expires: newsletterCookieDuration,
                    path: '/'
                })
            }

            toggleNewsletterPopup('close')
        }
    })
})
